import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { useSelector } from 'react-redux';

const TableSkeleton = ({ rows = 7, columns = 5 }) => {

  const themeStore = useSelector((state) => state.theme)

  return (
    <TableContainer component={Paper} style={{ background: themeStore.theme == "dark" ? `radial-gradient(circle at bottom, #1a1333 5%, #0C0A17  100%)` : "" }}>
      <Table>
        <TableHead>
          <TableRow>
            {[...Array(columns)].map((_, index) => (
              <TableCell key={index}>
                <Skeleton variant="text" width="80%" style={{ backgroundColor: 'gray' }} />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(rows)].map((_, rowIndex) => (
            <TableRow key={rowIndex}>
              {[...Array(columns)].map((_, colIndex) => (
                <TableCell key={colIndex}>
                  <Skeleton variant="text" width="100%" style={{ backgroundColor: 'gray' }} />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableSkeleton;
